var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecurityFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3627_52767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3168 2.88225L41.625 0L32.9333 2.88225C30.7305 3.61125 29.25 5.65875 29.25 7.9785V15.75C29.25 23.6722 37.2622 28.296 39.7147 29.5245L41.4787 30.4065L43.3035 29.6707C45.8123 28.6628 54 24.6758 54 15.75V7.9785C54 5.65875 52.5195 3.61125 50.3168 2.88225ZM51.75 15.75C51.75 23.265 44.6423 26.7075 42.462 27.5828L41.5755 27.9405L40.7205 27.513C38.5583 26.4307 31.4977 22.383 31.4977 15.75V7.9785C31.4977 6.63075 32.3573 5.44275 33.6375 5.0175L41.6227 2.3715L49.608 5.0175C50.8883 5.4405 51.7477 6.63075 51.7477 7.9785L51.75 15.75ZM22.5 18C22.5 15.5182 20.4818 13.5 18 13.5C15.5182 13.5 13.5 15.5182 13.5 18C13.5 20.4818 15.5182 22.5 18 22.5C20.4818 22.5 22.5 20.4818 22.5 18ZM15.75 18C15.75 16.7603 16.758 15.75 18 15.75C19.242 15.75 20.25 16.7603 20.25 18C20.25 19.2397 19.242 20.25 18 20.25C16.758 20.25 15.75 19.2397 15.75 18ZM24.75 33.75V29.25C24.75 28.0103 23.742 27 22.5 27H13.5C12.258 27 11.25 28.0103 11.25 29.25V33.75H9V29.25C9 26.7682 11.0182 24.75 13.5 24.75H22.5C24.9818 24.75 27 26.7682 27 29.25V33.75H24.75ZM42.75 5.625H40.5C38.0182 5.625 36 7.64325 36 10.125C36 12.6068 38.0182 14.625 40.5 14.625V23.625H45V21.375H42.75V14.625C45.2318 14.625 47.25 12.6068 47.25 10.125C47.25 7.64325 45.2318 5.625 42.75 5.625ZM42.75 12.375H40.5C39.258 12.375 38.25 11.3647 38.25 10.125C38.25 8.88525 39.258 7.875 40.5 7.875H42.75C43.992 7.875 45 8.88525 45 10.125C45 11.3647 43.992 12.375 42.75 12.375ZM54 27.603V42.75H28.125V51.75H40.5V54H13.5V51.75H25.875V42.75H0V5.625C0 2.5245 2.52225 0 5.625 0H28.7415C27.8955 0.62775 27.1823 1.395 26.5928 2.25H5.625C3.76425 2.25 2.25 3.76425 2.25 5.625V40.5H51.75V29.7743C52.5173 29.1353 53.2777 28.4175 54 27.603Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3627_52767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityFirst);
export default __webpack_public_path__ + "static/media/security-first.d2720d8fc029021ebe44fdfd2d0f9f92.svg";
export { ForwardRef as ReactComponent };